import React from 'react';
import { useParams } from 'react-router-dom';

import { OfferConfigurePageContainer } from '@occc-app/offerHelpers/components/OfferConfigurePageContainer';
import { OfferType } from '@occc-app/offerValidationService/types';
import { useChainId } from '@occc-app/Chain/hooks';
import { getCreatePageLinks, useGetCampaignName } from '@occc-app/routes/CampaignComponents/utils';

import { ChallengeConfigureFormContainer } from '../components/ChallengeConfigureForm/ChallengeConfigureFormContainer';
import { messages } from '../messages';

export const ChallengeConfigurePageContainer: React.FC = () => {
  const { id: campaignId = '', challengeId = '' } = useParams<{
    id: string;
    challengeId: string;
  }>();
  const chainId = useChainId();
  const campaignName = useGetCampaignName(chainId, campaignId);

  return (
    <OfferConfigurePageContainer
      campaignId={campaignId}
      offerId={challengeId}
      getBreadcrumbLinks={(offerName) => getCreatePageLinks(campaignId, campaignName, offerName)}
      pageTitle={messages.configurePageTitle}
      subtitle={messages.subtitle}
      offerType={OfferType.Challenge}
      ConfigureFormContainer={ChallengeConfigureFormContainer}
    />
  );
};
